import {
  UPLOADER_STATUS_UPLOADING,
  UPLOADER_STATUS_WAITING,
  type UploaderChunkState,
} from '../state';

export const resetIncompleteChunks = <ChunkMeta>(
  chunks: UploaderChunkState<ChunkMeta>[],
): UploaderChunkState<ChunkMeta>[] =>
  chunks.map((chunk) => {
    if (chunk.status === UPLOADER_STATUS_UPLOADING) {
      return {
        ...chunk,
        status: UPLOADER_STATUS_WAITING,
        uploaded: 0,
      };
    }
    return chunk;
  });

export const resetChunks = <ChunkMeta>(
  chunks: UploaderChunkState<ChunkMeta>[],
): UploaderChunkState<ChunkMeta>[] =>
  chunks.map((chunk) => ({
    ...chunk,
    status: UPLOADER_STATUS_WAITING,
    uploaded: 0,
    meta: undefined,
  }));
